import { useState, useEffect } from 'react';
import { api } from '../../api/client';

const COMMON_TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Toronto',
  'America/Vancouver',
  'America/Sao_Paulo',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Moscow',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Shanghai',
  'Asia/Tokyo',
  'Australia/Sydney',
  'Pacific/Auckland',
];

export function TimezoneSelector() {
  const [timezone, setTimezone] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.preferences.get()
      .then(prefs => setTimezone(prefs.timezone))
      .catch(() => setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone));
  }, []);

  const handleChange = async (tz: string) => {
    setTimezone(tz);
    setSaving(true);
    try {
      await api.preferences.update({ timezone: tz });
    } catch {
      // silent
    }
    setSaving(false);
  };

  if (!timezone) return null;

  return (
    <div className="flex items-center gap-3">
      <select
        value={timezone}
        onChange={e => handleChange(e.target.value)}
        className="flex-1 bg-[var(--color-bg-raised)] text-[var(--color-text-primary)] text-sm rounded-lg px-3 py-2 border border-[var(--color-border-subtle)] focus:outline-none focus:ring-1 focus:ring-[var(--color-accent)]"
      >
        {COMMON_TIMEZONES.map(tz => (
          <option key={tz} value={tz}>{tz.replace(/_/g, ' ')}</option>
        ))}
      </select>
      {saving && <span className="text-xs text-[var(--color-text-muted)]">Saving...</span>}
    </div>
  );
}
